export function roundFloat(number, decimals) {
  const dividor = decimals && decimals > 0 ? Math.pow(10, decimals) : 1;
  return Math.round((number + Number.EPSILON) * dividor) / dividor;
}

export function roundFloatToString(number, decimals) {
  return roundFloat(number, decimals).toFixed(decimals ? decimals : 0);
}
